import { sagaActions } from '@/redux/sagaActions'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useThemeAssets } from '@/ui-components/hooks/useThemeAssets'
import styled from 'styled-components'
import { Theme, ThemeMode } from '@/ui-components/constants/theme'
import { getThemeMode } from '@/ui-components/utils/theme-utils'
const LandingPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`

const LandingPageImage = styled.img`
  width: 200px;
  height: auto;
  max-width: 80%;
`

const LandingPage = () => {
  const dispatch = useDispatch()
  const { token } = useParams()
  const { svgAssets } = useThemeAssets()

  useEffect(() => {
    dispatch({
      type: sagaActions.INITIALIZE_STATE_TO_SERVER,
      payload: { token },
    })
  }, [dispatch, token])

  let logo = svgAssets.LOGO.light

  if (token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )
    const tokenInfo = JSON.parse(jsonPayload)
    const theme = tokenInfo.theme

    // Get theme mode
    const themeMode = getThemeMode(theme as Theme)

    // Get default logo based on theme mode (using dynamic assets from useThemeAssets)
    logo = svgAssets.LOGO[themeMode]

    // Override with custom logo if provided
    if (themeMode === ThemeMode.DARK) {
      if (tokenInfo.logo_url_dark && tokenInfo.logo_url_dark !== '') {
        logo = tokenInfo.logo_url_dark
      } else if (tokenInfo.logo_url && tokenInfo.logo_url !== '') {
        logo = tokenInfo.logo_url
      }
    }
    if (themeMode === ThemeMode.LIGHT) {
      if (tokenInfo.logo_url && tokenInfo.logo_url !== '') {
        logo = tokenInfo.logo_url
      } else if (tokenInfo.logo_url_dark && tokenInfo.logo_url_dark !== '') {
        logo = tokenInfo.logo_url_dark
      }
    }
  }

  return (
    <LandingPageContainer>
      <LandingPageImage src={logo} alt="logo" />
    </LandingPageContainer>
  )
}

export default LandingPage
